import { useEffect, useState } from "react";
import GroupFileCard from "../components/GroupFileCard";
import AccountGroupCard from "../components/AccountGroupCard";
import ScheduledPostCard from "../components/ScheduledPostCard";
import MainModal from "../components/MainModal";
import AddAccount, { ChooseGroup } from "../components/AddAccount";
import SelectVoice from "../components/SelectVoice";
import { useRedirect } from "../hooks/useRedirect";
import pathnames from "../routes/index.route";
import { ArrowRightIcon, BarChartIcon, CircleShapePlusIcon, VideoIcon, UploadIcon } from "../assets/icons/Icons";
import UploadFileModal, { UploadFileModalStep2, UploadFileModalStep3 } from "../components/UploadFileModal";
import { CardProfileSkeletonLoader, CardSkeletonLoader } from "../components/CardSkeletonLoader";


const Home = () => {
  const [showAccountModal, setShowAccountModal] = useState<boolean>(false);
  const [showVoiceModal, setShowVoiceModal] = useState<boolean>(false);
  const [showChooseGroup, setShowChooseGroup] = useState<boolean>(false);
  const [showUploadNF, setShowUploadNF] = useState<boolean>(false);
  const [showPreview, setShowPreview] = useState<boolean>(false);
  const [showChooseG, setShowChooseG] = useState<boolean>(false);
  const [loading, setLoading] = useState(true);
  const redirect = useRedirect();
  useEffect(() => {
    setTimeout(() => setLoading(false), 2000);
  }, []);
  return (
    <>
      <h1 className="text-[#0F0C18] text-[28px] font-medium leading-9 tracking-tight">Dashboard</h1>
      <h1 className="text-[#2C2135] mt-4 text-base font-medium tracking-tight">Instant actions</h1>
      <div className="flex items-center flex-wrap gap-2 mt-3">
        <div onClick={() => setShowUploadNF(true)} className="bg-gradient-to-b from-[#8C84FF] to-[#6158E0] w-[282px] h-[80px] rounded-xl p-[17px] cursor-pointer">
          <UploadIcon stroke="#FFFFFF" />
          <div className="flex items-center justify-between mt-3">
            <p className="text-white text-base font-medium leading-none tracking-tight">Upload file</p>
            <ArrowRightIcon />
          </div>
        </div>
        <div className="bg-gradient-to-b from-[#ffffff] to-[#ffffff] w-[282px] h-[80px] rounded-xl p-[17px] cursor-pointer">
          <BarChartIcon />
          <div className="flex items-center justify-between mt-3">
            <p className="text-[#0F0C18] text-base font-medium leading-none tracking-tight">Translate voice</p>
            <ArrowRightIcon stroke="#9392A2" opacity={1} />
          </div>
        </div>
        <div className="bg-gradient-to-b from-[#ffffff] to-[#ffffff] w-[282px] h-[80px] rounded-xl p-[17px] cursor-pointer">
          <VideoIcon />
          <div className="flex items-center justify-between mt-3">
            <p className="text-[#0F0C18] text-base font-medium leading-none tracking-tight">Translate video</p>
            <ArrowRightIcon stroke="#9392A2" opacity={1} />
          </div>
        </div>
        <div onClick={() => setShowAccountModal(true)} className="bg-gradient-to-b from-[#ffffff] to-[#ffffff] w-[282px] h-[80px] rounded-xl p-[17px] cursor-pointer">
          <CircleShapePlusIcon />
          <div className="flex items-center justify-between mt-3">
            <p className="text-[#0F0C18] text-base font-medium leading-none tracking-tight">Add account group</p>
            <ArrowRightIcon stroke="#9392A2" opacity={1} />
          </div>
        </div>
      </div>
      <div className="mt-[42px]">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-[6px]">
            <p className="text-[#2C2135] text-base font-medium tracking-tight">Group files</p>
            <p className="text-[#9391A2] text-sm font-medium tracking-tight">726 files</p>
          </div>
          <div onClick={() => redirect(pathnames.content)} className="flex items-center gap-1 cursor-pointer">
            <p className="text-[#9391A2] text-sm font-medium tracking-tight">See more</p>
            <ArrowRightIcon stroke="#0F0C18" opacity={1} />
          </div>
        </div>
      </div>
      <div className="mt-3 flex items-center gap-2 flex-wrap">
        {
          loading ?
            [...Array(6)].map((_, index) => <CardSkeletonLoader key={index} />) :
            [...Array(6)].map((_, index) => <GroupFileCard key={index} />)
        }
      </div>
      <div className="mt-[40px]">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-[6px]">
            <p className="text-[#2C2135] text-base font-medium tracking-tight">Accounts</p>
            <p className="text-[#9391A2] text-sm font-medium tracking-tight">6 groups</p>
          </div>
          <div onClick={() => redirect(pathnames.accounts)} className="flex items-center gap-1 cursor-pointer">
            <p className="text-[#9391A2] text-sm font-medium tracking-tight">See more</p>
            <ArrowRightIcon stroke="#0F0C18" opacity={1} />
          </div>
        </div>
      </div>
      <div className="mt-3 flex items-center gap-2 flex-wrap">
        {
          loading ?
            [...Array(6)].map((_, index) => <CardProfileSkeletonLoader key={index} />) :
            [...Array(6)].map((_, index) => <AccountGroupCard key={index} />)
        }
      </div>
      <div className="mt-[40px]">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-[6px]">
            <p className="text-[#2C2135] text-base font-medium tracking-tight">Scheduled post</p>
            <p className="text-[#9391A2] text-sm font-medium tracking-tight"></p>
          </div>
          <div onClick={() => redirect(pathnames.scheduledPost)} className="flex items-center gap-1 cursor-pointer">
            <p className="text-[#9391A2] text-sm font-medium tracking-tight">See more</p>
            <ArrowRightIcon stroke="#0F0C18" opacity={1} />
          </div>
        </div>
      </div>
      <div className="mt-3 flex items-center gap-2 flex-wrap">
        {
          loading ?
            [...Array(6)].map((_, index) => <CardSkeletonLoader key={index} />) :
            [...Array(6)].map((_, index) => <ScheduledPostCard key={index} />)
        }
      </div>
      {
        showAccountModal &&
        <MainModal
          subLabel="Step 1 of 3"
          setShowModal={setShowAccountModal}
        >
          <AddAccount showNext={() => {
            setShowAccountModal(false);
            setShowChooseGroup(true);
          }} />
        </MainModal>
      }
      {
        showChooseGroup &&
        <MainModal
          subLabel="Step 2 of 3"
          setShowModal={setShowChooseGroup}
        >
          <ChooseGroup
            showPrev={() => {
              setShowChooseGroup(false);
              setShowAccountModal(true);
            }}
            showNext={() => {
              setShowChooseGroup(false);
              setShowVoiceModal(true);
            }}
          />
        </MainModal>
      }
      {
        showVoiceModal &&
        <MainModal
          label="Select voice"
          setShowModal={setShowVoiceModal}
        >
          <SelectVoice />
        </MainModal>
      }
      {
        showUploadNF &&
        <MainModal
          subLabel="Step 1 of 3"
          setShowModal={setShowUploadNF}
        >
          <UploadFileModal showNext={() => {
            setShowUploadNF(false)
            setShowPreview(true)
          }} />
        </MainModal>
      }
      {
        showPreview &&
        <MainModal
          subLabel="Step 2 of 3"
          setShowModal={setShowPreview}
        >
          <UploadFileModalStep2 showNext={() => {
            setShowPreview(false)
            setShowChooseG(true)
          }} />
        </MainModal>
      }
      {
        showChooseG &&
        <MainModal
          subLabel="Step 3 of 3"
          setShowModal={setShowChooseG}
        >
          <UploadFileModalStep3 showPrev={() => {
            setShowChooseG(false)
            setShowPreview(true)
          }} />
        </MainModal>
      }
    </>
  );
};

export default Home;